import React, {useMemo} from 'react'
import styles from './UIGameBarbarianInvasionTrackerContainer.module.scss'
import {MechanicValidatorBarbarianInvasion} from '@colonist/game-mechanic-validators'
import {useBarbarianInvasionValidator} from '../../store/selectors/useBarbarianInvasionValidator'
import {useKnightValidator} from '../../store/selectors/useKnightValidator'
import {UIGameBarbarianInvasionTracker} from './UIGameBarbarianInvasionTracker'

export const UIGameBarbarianInvasionTrackerContainer = () => {
    const barbarianInvasionValidator = useBarbarianInvasionValidator()
    const knightValidator = useKnightValidator()
    if(barbarianInvasionValidator == undefined || knightValidator == undefined) return null

    const barbarianProgress = useMemo(() => barbarianInvasionValidator.getBarbarianProgress(), [barbarianInvasionValidator])
    const barbarianStrength = useMemo(() => barbarianInvasionValidator.getBarbarianStrength(), [barbarianInvasionValidator])
    const knightStrength = useMemo(() => knightValidator.getTotalKnightStrength(), [knightValidator])
    const progressWhenBarbariansAttack = MechanicValidatorBarbarianInvasion.PROGRESS_WHEN_BARBARIANS_ATTACK

    return <div className={styles.barbarianInvasionTrackerContainer}>
        <UIGameBarbarianInvasionTracker
            barbarianProgress={barbarianProgress}
            barbarianStrength={barbarianStrength}
            knightStrength={knightStrength}
            progressWhenBarbariansAttack={progressWhenBarbariansAttack}
        />
    </div>
}
